import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { transformReviewsTemplateToUseProductForContextIfNecessary } from "./defaultComponentTemplate";

export const shopifyProductRatingWidget: ComponentTemplate = {
  id: "ae5b4ad3-38d3-48af-835c-72f5bb93b4af",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Shopify Product Rating",
  leftBarCategory: { main: "productIntegrations", subCategory: "shopify" },
  preview: "integrations/shopify-product-rating.svg",
  transforms: [transformReviewsTemplateToUseProductForContextIfNecessary],
  tags: ["reviews", "star", "widget"],
  template: {
    id: "$uid",
    type: "shopifyProductRatingWidget",
    props: { style: { alignSelf: "stretch" } },
  },
};
